import React from 'react';

import cn from 'classnames';

import TreeNode from './TreeNode';

function TreeView({ baseLevel, breakdown, setShowElements }) {
  return (
    <ul
      className={cn({
        'table__tree__base-level': baseLevel,
      })}
    >
      {breakdown.map((item) => (
        <TreeNode
          key={item.id}
          node={item}
          baseLevel={baseLevel}
          children={item.children}
          setShowElements={setShowElements}
        />
      ))}
    </ul>
  );
}

export default TreeView;
